import React, { useMemo } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const DeleteConfirmationDialog = ({ visible, onHide, onConfirm, item }) => {
    const isPartnerRecipe = Boolean(item?.isPartnerRecipe);
    const title = useMemo(() => item?.title || 'this recipe', [item]);

    return (
        <Dialog
            visible={visible}
            className="delete-dialog frazza-dialog-md"
            header="Delete Recipe"
            modal
            dismissableMask
            footer={(
                <>
                    <Button
                        label="Cancel"
                        icon="pi pi-times"
                        className="p-button-text"
                        onClick={onHide}
                    />
                    <Button
                        label={isPartnerRecipe ? 'Delete (disabled)' : 'Delete'}
                        icon="pi pi-trash"
                        className="p-button-danger"
                        onClick={onConfirm}
                        disabled={isPartnerRecipe}
                    />
                </>
            )}
            onHide={onHide}
        >
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem', marginBottom: '1.5rem' }}>
                <div className="frazza-alert-icon danger">
                    <i className="pi pi-exclamation-triangle" />
                </div>
                <div>
                    <h3 className="frazza-alert-title">Delete "{item?.title || 'Recipe'}"?</h3>
                    <p className="frazza-alert-message">This recipe will be permanently removed from your collection. This action cannot be undone.</p>
                </div>
            </div>

            <div className="delete-preview">
                {item?.image && (
                    <img src={item.image} alt={item?.title || 'Recipe'} className="delete-preview-img" />
                )}
                <div className="delete-preview-info">
                    <div className="delete-preview-title">{item?.title || 'Recipe'}</div>
                    <div className="delete-meta">
                        {item?.mealType && (
                            <span><i className="pi pi-tag" /> {item.mealType}</span>
                        )}
                        {item?.prepTime != null && (
                            <span><i className="pi pi-clock" /> {item.prepTime} min</span>
                        )}
                        {item?.servings != null && (
                            <span><i className="pi pi-users" /> {item.servings}</span>
                        )}
                    </div>
                    {isPartnerRecipe && (
                        <div className="delete-warning">You cannot delete a partner’s recipe.</div>
                    )}
                </div>
            </div>
        </Dialog>
    );
};

export default DeleteConfirmationDialog; 